import { useMemo } from "react";

import { subSeconds } from "date-fns";

import { useAppSelector } from "@/data/hooks";
import { selectWritingDate } from "@/features/timeline";

/**
 * Slack between a recording ending and the exam closing. Athena's
 * `reservedVivaSeconds` mirrors it.
 */
const RECORDING_BUFFER_SECONDS = 5;

/**
 * Get the latest time a new Socratic Dialogue/attempt can start and still have
 * enough time to record before a timed assessment closes.
 *
 * Times come from the Socratic Session, so special considerations are included.
 */
export function useRecordingStartCutoff(
  readingTimeSeconds: number | null,
  responseTimeSeconds: number | null
): Date | null {
  const writingDate = useAppSelector(selectWritingDate);

  return useMemo(() => {
    if (writingDate == null) return null;
    if (readingTimeSeconds == null || responseTimeSeconds == null) return null;

    const cutoff =
      readingTimeSeconds + responseTimeSeconds + RECORDING_BUFFER_SECONDS;

    return subSeconds(new Date(writingDate), cutoff);
  }, [writingDate, readingTimeSeconds, responseTimeSeconds]);
}
